import type { WamFile } from "@workadventure/map-editor";
import { ResizeMapCommand } from "@workadventure/map-editor";
import type { GameMapFrontWrapper } from "../../../GameMap/GameMapFrontWrapper";
import type { FrontCommandInterface } from "../FrontCommandInterface";
import type { RoomConnection } from "../../../../../Connection/RoomConnection";

export class ResizeMapFrontCommand extends ResizeMapCommand implements FrontCommandInterface {
    private readonly oldWidth: number;
    private readonly oldHeight: number;

    constructor(
        wamFile: WamFile,
        width: number,
        height: number,
        commandId: string | undefined,
        private gameMapFrontWrapper: GameMapFrontWrapper,
    ) {
        super(wamFile, width, height, commandId);
        this.oldWidth = gameMapFrontWrapper.getMap().width ?? 0;
        this.oldHeight = gameMapFrontWrapper.getMap().height ?? 0;
    }

    public async execute(): Promise<void> {
        await super.execute();
        this.gameMapFrontWrapper.resizeMap(this.width, this.height);
    }

    public getUndoCommand(): ResizeMapFrontCommand {
        return new ResizeMapFrontCommand(
            this.wamFile,
            this.oldWidth,
            this.oldHeight,
            undefined,
            this.gameMapFrontWrapper,
        );
    }

    public emitEvent(roomConnection: RoomConnection): void {
        roomConnection.emitMapEditorResize(this.commandId, this.width, this.height);
    }
}
